import { render, staticRenderFns } from "./bookingdetails.vue?vue&type=template&id=016255d8&scoped=true&"
import script from "./bookingdetails.vue?vue&type=script&lang=js&"
export * from "./bookingdetails.vue?vue&type=script&lang=js&"
import style0 from "./bookingdetails.vue?vue&type=style&index=0&id=016255d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016255d8",
  null
  
)

export default component.exports